module.exports = __webpack_public_path__ + "img/flag-06.02e191ad.svg";